export const extractAttributesFromProducts = (products: Array<GQL.IProduct>) => {
    const variants = new Array<GQL.IProductVariant>();

    for (const product of products) {
        variants.push(...(product.variants || []));
    }

    const attributes: { [attributeId: string]: { [valueId: string]: any } } = {};
    for (const variant of variants) {
        if (variant.definition == undefined) {
            continue;
        }

        // super-ugly solution
        for (const attributeId of Object.keys(variant.definition)) {
            if (attributes[attributeId]) {
                if (Array.isArray(variant.definition[attributeId])) {
                    variant.definition[attributeId].forEach((attributeValueId: string) => {
                        attributes[attributeId][attributeValueId] = undefined;
                    });
                } else {
                    attributes[attributeId][variant.definition[attributeId]] = undefined;
                }
            } else {
                attributes[attributeId] = { [variant.definition[attributeId]]: undefined };
            }
        }
    }

    return attributes;
};



// WEBPACK FOOTER //
// ./src/helpers/attributes/extractAttributesFromProducts.ts